import { allergns } from '@components/Allergns/Allergns';
import { Grow } from '@material-ui/core';
import React from 'react';
import styled from 'styled-components';

export const Footer = () => {
  return (
    <Grow in timeout={2400}>
      <AllergnsWrapper>
        <AllergnsTitle>Alérgenos</AllergnsTitle>
        <Allergns>
          {allergns.map((allergn, index) => (
            <div
              key={index}
              style={{
                flex: '1 0 48%',
                display: 'flex',
                gap: 20,
              }}
            >
              {React.createElement(allergn.icon, {
                width: 28,
                height: 28,
                key: allergn.name,
              })}
              <span
                style={{
                  color: 'black',
                  fontFamily: 'Poppins',
                }}
              >
                {allergn.label}
              </span>
            </div>
          ))}
        </Allergns>
        <InfoIVA>I.V.A Incluido en todos los precios</InfoIVA>
      </AllergnsWrapper>
    </Grow>
  );
};

const InfoIVA = styled.span`
  margin-top: 1rem;
  font-weight: bold;
`;

const AllergnsTitle = styled.h2`
  color: black;
  font-family: 'Poppins';
`;

const Allergns = styled.div`
  display: flex;
  justify-content: center;
  gap: 10px;
  flex-wrap: wrap;
`;

const AllergnsWrapper = styled.footer`
  margin-top: 3.5rem;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  padding: 20px;
  margin-bottom: 0;
  background: white;
  border-radius: 0.5rem;
  color: black;
`;
